import {useRef} from 'react';

export const getBaseUrl=(env)=> {
    let protocol = window.location.protocol;
    let hostUrl = window.location.host;
    //let pathName =window.location.pathname.replace("ui","rest");
    switch(env) {
        case "local":
            return 'https://wwwdev.appmybizaccount.ebc.gov.on.ca/onbis_onprem/CompanyKey_API';
           //return 'http://localhost:14100/onbis/CompanyKey_API';
        case "dev2":
            return protocol + '//' + hostUrl + '/onbis_onprem/CompanyKey_API';
        default:
            return protocol + '//' + hostUrl + '/onbis/CompanyKey_API';
    }
}

export const getDate = (dateStr, locale) => {
    let fomattedDate = "";
    if(dateStr){
      const dateArray = dateStr.split("-");
      let year = dateArray[0];
      let month = dateArray[1] - 1;
      let day = dateArray[2];
      let date = new Date(year, month, day);

      fomattedDate = date.toLocaleDateString(locale, { month: 'long' }) 
      + " "
      + date.toLocaleDateString(locale, { day: '2-digit' })
      + ", " 
      +  date.toLocaleDateString(locale, { year: 'numeric' })
      ;
    }
    return fomattedDate;
};

export const getCurrentYear = () => {
    let date = new Date();
    return date.toLocaleDateString('en-CA', { year: 'numeric' });
};
